module.exports = __webpack_public_path__ + "img/coverage-1.d4284fdb.svg";